<!--Block：标题+描述+Card-->
<template>
  <div class="v-block" >
    <div :class="blockClass" :style="blockVal.title?'padding:0.6rem 0;':''">
      <!-- 标题 -->
      <div class="blockTitle" v-if="blockVal.title" v-html="blockVal.title"></div>
      <!-- 简介 -->
      <div class="blockContent" v-if="blockVal.summary" v-html="mark(blockVal.summary)"></div>
      <!-- Card -->
      <v-card :card-val="blockVal.cards"  v-if="blockVal.cards.length>0"></v-card>
    </div>
  </div>
</template>

<script>
import card from "@/components/card"
import marked from 'marked'
export default {
  name: 'v-block',
  components:{
    "v-card":card,//块组件
  },
  props: {
      blockVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data () {
    return {
      defaultOpen:"preview",
      blockClass:"full",//full center 默认充满 （非必填）
    }
  },
  created(){
    var that = this;
    // that.blockClass = that.getAttr(that.blockVal.attr,'cotainer');
    that.blockClass = (that.blockVal.attr!==''&&that.blockVal.attr!==undefined)? that.getValue(JSON.parse(that.blockVal.attr)):"";
  },
  methods:{
    linkUrl(){
      this.$router.push({'name':'product'});
    },
    //转换md格式
    mark(_value){
      return marked(_value);
    },
    //获取属性值JS 遍历Key、Value字典对象
    getValue(_attr){
      var str = "";
      for(var key in _attr){
        // console.log("key:::",_attr[key]);
        str += _attr[key]+' ';
      }
      // console.log("blockstr:::",str);
      return str;
    },
    getAttr(_attr){
      var str = "";
      for(var key in _attr){
        // console.log("key:::",_attr[key]);
        str += _attr[key]+' ';
      }
      // console.log("blockstr:::",str);
      return str;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>
